// src/firebaseApp.js

// Use the v9 "compat" layer so v8-style code works
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
// (add others if your app uses them)
// import 'firebase/compat/firestore';
// import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCjLA6bjs8wgHjTtZLRuhuPkglAaJWk7Ho",
    authDomain: "livenass.firebaseapp.com",
    projectId: "livenass",
    storageBucket: "livenass.firebasestorage.app",
    messagingSenderId: "925096702495",
    appId: "1:925096702495:web:9a44bd26f26340bcda9b2a",
    measurementId: "G-VW9DNBEKGR",
};

// Initialize the default app for compat API
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export default firebase;
